import { usersService } from '../../helpers/services/users.service';
import i18n from '@/i18n';
// import router from '@/router/index';
import { sharedHelper, filtersHelper } from '@/utils';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const USERS_MODULE = 'users';

// ACTIONS
export const GET_ALL_USER = 'getAllUser';
export const GET_USERS = 'getUsers';
export const UPDATE_USERS = 'updateUsers';

// MUTATIONS
const REQUESTING = 'requesting';
const ALL_USERS_SUCCESS = 'allUsersSuccess';
const SUCCESS = 'commonSuccess';
const FAILURE = 'commonFailure';
const GET_USERS_SUCCESS = 'getUsersSuccess';

export const actions = {
    [GET_ALL_USER]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        usersService
            .getAllUsers(filter)
            .then((result) => {
                commit(ALL_USERS_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [GET_USERS]({commit}, {id}) {
        commit(REQUESTING, 'detail');
        return usersService
                .getUser(id)
                .then((result) => {
                    commit(SUCCESS);
                    commit(GET_USERS_SUCCESS, result);
                    return result;
                })
                .catch((error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                    commit(FAILURE);
                });
    },
    [UPDATE_USERS]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return usersService
            .updateUser(data)
            .then((result) => {
                var message = i18n.t('label.updateX', [i18n.t('module.userGroup')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                dispatch(GET_ALL_USER, {filter});
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
};

export const mutations = {
    [ALL_USERS_SUCCESS](state, {data}) {
        let users = data.data || [];
        state.list.data = users;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);
        if(data.success) {
            state.list.data = users.map(item => {
                return {
                    id: item.uuid,
                    name: item.name,
                    email: item.email,
                    isVerified: item.is_verified,
                    isLocked: item.is_locked,
                    isActive: item.is_active,
                    createdBy: item.created_by,
                    createdAt: filtersHelper.getDateFormat(item.created_at),
                    updatedBy: item.updated_by,
                    updatedAt: filtersHelper.getDateFormat(item.updated_at),
                    groups: item?.groups?.map(item => (item.name)) || [],
                };
            });
        }
    },
    [GET_USERS_SUCCESS](state, data) {
        let item = data.data;
        state.details = {
            id: item.uuid,
            name: item.name,
            email: item.email,
            isVerified: item.is_verified,
            isLocked: item.is_locked,
            isActive: item.is_active,
            createdBy: item.created_by,
            createdAt: filtersHelper.getDateFormat(item.created_at),
            updatedBy: item.updated_by,
            updatedAt: filtersHelper.getDateFormat(item.updated_at),
            roles: item.roles,
            groups: item?.groups || [],
        };
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};